import { Facility } from 'interfaces/facility';
import { FC, useEffect } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
// import { IoIosAdd, IoMdTrash } from 'react-icons/io';
// import DebouncedInput from 'components/UI/DebouncedInput/DebouncedInput';
// import { toast } from 'react-hot-toast';
// import ListPagination from 'components/UI/ListPagination/ListPagination';
// import { PaginationState } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { facilityActions } from 'store/slices/facility';
import { FacilityResponse } from 'services/FacilityService';

/**
 * Props for the FacilityList component
 * @typedef {Object} FacilityListProps
 * @property {FacilityResponse | undefined} facilityResponse - The response containing facility records
 * @property {Function} updateFilter - Function to update the filter for facilities
 * @property {boolean} refetch - Flag indicating whether to refetch data
 */
type FacilityListProps = {
  facilityResponse: FacilityResponse | undefined;
  updateFilter: Function;
  // onDelete: Function;
  // canManage: boolean;
  // setPagination: Dispatch<SetStateAction<PaginationState>>;
  // pagination: PaginationState;
  refetch: boolean;
};

/**
 * @description Component that displays a list of facilities
 *
 * @SADtrace SAD-003-3.1
 *
 * @component
 * @param {FacilityListProps} props - The component props
 * @param {FacilityResponse | undefined} props.facilityResponse - The response containing facility records
 * @param {Function} props.updateFilter - Function to update the filter for facilities
 * @param {boolean} props.refetch - Flag indicating whether to refetch data
 * @returns {JSX.Element} The rendered FacilityList component
 */
const FacilityList: FC<FacilityListProps> = ({
  facilityResponse,
  updateFilter,
  refetch,
  // onDelete,
  // canManage,
  // setPagination,
  // pagination,
}) => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const clearSearch: boolean = useSelector(
    (state: any) => state.facility.clearSearch,
  );
  const dispatch = useDispatch();
  // const [search, setSearch] = useState<string>('');

  // const handleAddClick = () => {
  //   if (!facilityResponse?.records) return;

  //   const facilityExists = facilityResponse?.records.find(
  //     (facility: Facility) =>
  //       facility.name.toLowerCase().trim() === search.toLowerCase().trim()
  //   );

  //   if (facilityExists) {
  //     toast.error(
  //       t('facilities.messages.name__exists', { name: facilityExists.name })
  //     );
  //     return false;
  //   }

  //   navigate({
  //     pathname: '/facilities/add',
  //     search: `?name=${search}`,
  //   });
  // };

  useEffect(() => {
    if (!params.id && facilityResponse?.records.length && !refetch) {
      navigate(`/facilities/${facilityResponse.records[0].id}`);
    }
  }, [facilityResponse, refetch, params.id, navigate]);

  useEffect(() => {
    if (clearSearch) {
      // setSearch('');
      updateFilter('');
      dispatch(facilityActions.resetClearSearch());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearSearch]);

  return (
    <>
      <div className="master-list__search-wrapper">
        {/* <DebouncedInput
          placeholder={t('facilities.search_box')}
          value={search}
          type="text"
          onChange={(value) => {
            setSearch(value as string);
            updateFilter(value);

            //set pagination back to first page
            setPagination((oldValue) => ({
              ...oldValue,
              pageIndex: 0,
            }));
          }}
          className="form-control form-control rounded mb-2"
        /> */}

        {/* {canManage ? (
          <button
            className="btn-rounded btn-rounded-sm master-list__button-add"
            onClick={handleAddClick}
            data-testid="add"
          >
            <IoIosAdd size={40} />
          </button>
        ) : null} */}
      </div>

      {facilityResponse?.records.length === 0 && (
        <div className="alert mb-0">{t('messages.no_records')}</div>
      )}

      {facilityResponse && facilityResponse?.records.length > 0 && (
        <div className="master-list master-list__no-scroll">
          {facilityResponse.records.map((facility: Facility) => {
            return (
              <NavLink
                to={`/facilities/${facility.id}`}
                className="master-list__item"
                key={facility.id}
              >
                {facility.name}

                {/* {canManage && (
                  <button
                    className="master-list__item-delete"
                           onClick={(e) => {
                        e.stopPropagation();
                        onDelete(facility);
                      }}
                    data-testid="delete"
                  >
                    <IoMdTrash size={26} />
                  </button>
                )} */}
              </NavLink>
            );
          })}
          {/* <ListPagination
            canGetNextPage={
              Number(facilityResponse.pageIndex + 1) <
              Number(facilityResponse.totalPages)
            }
            canGetPreviousPage={Number(facilityResponse.pageIndex) > 0}
            nextPage={() => {
              setPagination({
                ...pagination,
                pageIndex: pagination.pageIndex + 1,
              });
            }}
            previousPage={() => {
              setPagination({
                ...pagination,
                pageIndex: pagination.pageIndex - 1,
              });
            }}
            pageCount={facilityResponse.totalPages}
            pageIndex={pagination.pageIndex}
            pageSize={pagination.pageSize}
            setPageSize={(pageSize: number) =>
              setPagination({
                ...pagination,
                pageSize,
              })
            }
            setPageIndex={(pageIndex: number) =>
              setPagination({
                ...pagination,
                pageIndex,
              })
            }
            hidePageSize
          /> */}
        </div>
      )}
    </>
  );
};

export default FacilityList;
